import * as React from 'react';
import BaseButton, { ButtonProps } from '@magoosh/lib/button/base';
import style from './style.module.scss';
import cx from 'classnames';

interface CustomProps extends ButtonProps {
  bsClass: string;
  borderless?: boolean;
}

export const PrimaryButton = (props: ButtonProps) => {
  return <BaseButton {...props} style="primary" />;
};
export const SecondaryButton = (props: ButtonProps) => {
  return <BaseButton {...props} style="secondary" />;
};
export const InfoButton = (props: ButtonProps) => {
  return <BaseButton {...props} style="info" />;
};
export const DefaultButton = (props: ButtonProps) => {
  return <BaseButton {...props} style="default" />;
};
export const DangerButton = (props: ButtonProps) => {
  return <BaseButton {...props} style="danger" />;
};
export const BorderlessButton = (props: ButtonProps) => {
  return <BaseButton {...props} className={cx(style.borderlessButton, props.className)} style="default" />;
};

/**
 * TabButton (dark gray) is used to provide affordance as to what content they are navigated to.
 */
export const TabButton = (props: ButtonProps) => {
  return (
    <BorderlessButton
      className={cx(style.tabButton, 'btn')}
      bsClass="default"
      style="default"
      size="lg"
      {...props}>
      {props.children}
    </BorderlessButton>
  );
};

/**
 * SelectButton (purple) is used to denote that a user choice has consequences for their experience.
 */
export const SelectButton = (props: ButtonProps) => {
  return (
    <BorderlessButton
      className={cx(style.selectButton, 'btn')}
      bsClass="default"
      style="default"
      size="lg"
      {...props}>
      {props.children}
    </BorderlessButton>
  );
};

export const LinkButton = (props: ButtonProps) => {
  return (
    <BaseButton {...props} className={cx(style.linkButton, props.className, 'btn-multi-line btn-link')} />
  );
};

/**
 * Don't use this
 */
export const CustomButton = (props: CustomProps) => {
  return (
    <BaseButton {...props} className={cx(props.borderless && style.borderlessButton, props.className)} />
  );
};
